export default __webpack_public_path__ + "media/Confluence_tablet.2f1d5cdb5df6b381b88f6dd55c57958c.svg";